import styled from '@emotion/styled';

export const LoginContainer = styled.div`
  margin: auto;
  display: grid;
  grid-template-columns: auto 680px;
  gap: 0px;
  align-items: flex-start;
  height: 100vh;
  overflow: auto;
  position: relative;
  @media (max-width: 1150px) {
    grid-template-columns: auto 580px;
  }
  @media (max-width: 977px) {
    grid-template-columns: auto 450px;
  }
  @media (max-width: 825px) {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
`;

export const List = styled.ul`
  list-style: none;
  padding-left: 0;
  margin-top: 40px;
  margin-bottom: 60px;
`;
export const ListItem = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  font-size: ${(props) => props.theme.font.h3.fontSize};
  font-weight: ${(props) => props.theme.font.h3.fontWeight};
  font-family: ${(props) => props.theme.font.h3.fontFamily};
  color: ${(props) => props.theme.colors.text.seconday};
  @media (max-width: 768px) {
    font-size: ${(props) => props.theme.font.body.fontSize};
  }
`;

export const LogoStyle = {
  height: '40px',
  width: '209px',
  marginBottom: '75px',
};
